import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Users, 
  Settings, 
  Globe, 
  Fish,
  Calendar,
  CreditCard,
  Terminal, // Added
  Building2 // Added
} from 'lucide-react';

interface SidebarLink {
  to: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
}

const links: SidebarLink[] = [
  { to: '/admin/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/admin/users', label: 'Usuários', icon: Users },
  { to: '/admin/tenants', label: 'Empresas', icon: Building2 },
  { to: '/admin/feed', label: 'Feed', icon: Fish },
  { to: '/admin/site-builder', label: 'Construtor de Sites', icon: Globe },
  { to: '/admin/bookings', label: 'Reservas', icon: Calendar },
  { to: '/admin/clients', label: 'Clientes', icon: Users },
  { to: '/admin/financials', label: 'Financeiro', icon: CreditCard },
  { to: '/admin/domains', label: 'Domínios', icon: Globe },
  { to: '/admin/settings', label: 'Configurações', icon: Settings },
  { to: '/admin/developer', label: 'Developer', icon: Terminal },
  { to: '/admin/profile', label: 'Meu Perfil', icon: Users },
];

export const AdminSidebar: React.FC = () => {
  return (
    <aside className="hidden sm:flex flex-col items-center w-16 lg:w-64 border-r border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 h-screen sticky top-0 transition-all duration-300">
      {/* Logo Area */}
      <div className="h-16 flex items-center justify-center border-b border-slate-100 dark:border-slate-800 w-full">
        <div className="flex items-center gap-3">
          <div className="inline-flex size-10 items-center justify-center rounded-lg bg-blue-600 text-white shrink-0">
            <Fish className="size-6" />
          </div>
          <span className="font-bold text-xl text-slate-900 dark:text-slate-100 hidden lg:block">
            Nossa Pesca
          </span>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 w-full px-2 py-4 space-y-1">
        {links.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            className={({ isActive }) => `
              flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors group
              ${isActive 
                ? 'bg-blue-50 text-blue-600 dark:bg-blue-900/20 dark:text-blue-400' 
                : 'text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 hover:text-slate-900 dark:hover:text-slate-100'
              }
            `}
            title={link.label}
          >
            <link.icon className="size-5 shrink-0" />
            <span className="font-medium hidden lg:block">{link.label}</span>
          </NavLink>
        ))}
      </nav>

      {/* Footer / User Preview could go here */}
    </aside>
  );
};
